import { useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import BackButton from "../components/BackButton";


const ImageFilterGenerator = () => {
  const [imageURL, setImageURL] = useState(null);
  const [filters, setFilters] = useState({
    brightness: 100,
    contrast: 100,
    saturate: 100,
    grayscale: 0,
    sepia: 0,
    blur: 0,
    invert: 0,
    hueRotate: 0,
  });

  const fileInputRef = useRef();

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageURL(URL.createObjectURL(file));
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: Number(value) });
  };

  const resetFilters = () => {
    setFilters({
      brightness: 100,
      contrast: 100,
      saturate: 100,
      grayscale: 0,
      sepia: 0,
      blur: 0,
      invert: 0,
      hueRotate: 0,
    });
  };

  const getFilterCSS = () => {
    return `brightness(${filters.brightness}%) contrast(${filters.contrast}%) saturate(${filters.saturate}%) grayscale(${filters.grayscale}%) sepia(${filters.sepia}%) blur(${filters.blur}px) invert(${filters.invert}%) hue-rotate(${filters.hueRotate}deg)`;
  };

  const copyCSS = () => {
    const css = `filter: ${getFilterCSS()};`;
    navigator.clipboard.writeText(css);
    alert("CSS copied to clipboard!");
  };

  return (
    <>
      <Helmet>
        <title>Image CSS Filter Generator Online</title>
        <meta
          name="description"
          content="Apply CSS filters to any image (SVG, PNG, JPG) and copy the filter code instantly. Supports all formats with real-time preview."
        />
        <meta name="keywords" content="image filter generator, css filter tool, brightness, contrast, grayscale, blur, hue rotate, online filter preview" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/image-filter-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
         <BackButton />
          <h2>Image CSS Filter Generator</h2>

          <div className="col-lg-12 mb-3">
            <input type="file" accept="image/*" onChange={handleImageUpload} ref={fileInputRef} className="form-control" />
          </div>

          {imageURL && (
            <div className="row">
              <div className="col-lg-6 mb-3 text-center">
                <div className="cntrimg">
                  <img
                  src={imageURL}
                  alt="Uploaded"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '300px',
                    filter: getFilterCSS(),
                  }}
                />
                </div>
              </div>

               <div className="col-lg-6">
                {Object.entries(filters).map(([key, value]) => (
                  <div className="mb-3" key={key}>
                    <label className="form-label">
                      {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                      {key === 'blur' ? 'px' : key === 'hueRotate' ? '°' : '%'}
                    </label>
                    <input
                      type="range"
                      min={key === 'blur' ? 0 : key === 'hueRotate' ? 0 : 0}
                      max={key === 'blur' ? 20 : key === 'hueRotate' ? 360 : 200}
                      name={key}
                      value={value}
                      onChange={handleFilterChange}
                      className="form-range"
                    />
                  </div>
                ))}
              </div>
              <div className="col-lg-12 mb-3">
                <label className="form-label">Generated CSS:</label>
                <textarea
                  className="form-control"
                  rows="3"
                  readOnly
                  value={`filter: ${getFilterCSS()};`}
                />
              </div>

              <div className="col-lg-12 d-flex gap-2 mb-4">
                <button className="btn btn-success" onClick={copyCSS}>Copy CSS</button>
                <button className="btn btn-danger" onClick={resetFilters}>Reset Filters</button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ImageFilterGenerator;
